import axios from "axios";
import Vue from "vue";
import store from "@/store";
import { getToken } from "@/utils/auth";
import errorCode from "./errorCode"; // 状态码
import NProgress from "nprogress"; // Progress 进度条
import "nprogress/nprogress.css"; // Progress 进度条样式
import { message } from "ant-design-vue";
import { sign } from 'ljzn-sass-sign'

// 是否显示重新登录
let isReloginShow;
let vm = new Vue();
// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    console.log("config", config);
    NProgress.start();
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    if (getToken() && !isToken) {
      // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers["Authorization"] = "Bearer " + getToken();
    }
    // 签名
    const resObj = sign(config);
    const keyArr = Object.keys(resObj);
    keyArr.forEach((key) => {
     config.headers[key] = resObj[key];
    });
    return config;
  },
  (error) => {
    NProgress.done();
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    NProgress.done();

    const res = response.data;
    const code = res.err_code || 200;
    // 错误信息
    // const message = errorCode[code] || res.err_msg || errorCode['default']
    const mess = res.err_msg || errorCode["default"];
    if (code === 4001) {
      if (!isReloginShow) {
        isReloginShow = true;
        vm.$confirm({
          title: "系统提示",
          content: "登录状态已过期，您可以继续留在该页面，或者重新登录",
          okText: "确认",
          cancelText: "取消",
          onOk() {
            isReloginShow = false;
            store.dispatch("logout");
          },
          onCancel() {
            isReloginShow = false;
          },
        });
      }
      return Promise.reject("无效的会话，或者会话已过期，请重新登录。");
    } else if (code === 4005 || code === 4004 || code === 4006) {
      messageError(mess);
      return Promise.reject(new Error(mess));
    } else if (!res.err_code) {
      console.log("导出", response);
      return response;
    } else if (code !== 200) {
      // messageError(mess);
      // return Promise.reject(new Error(mess));
    } else {
      return res;
    }
  },
  (error) => {
    NProgress.done();
    console.log("err" + error); // for debug
    let { mess } = error;
    if (mess === "Network Error") {
      mess = "后端接口连接异常";
    } else if (mess.includes("timeout")) {
      mess = "系统接口请求超时";
    } else if (mess.includes("Request failed with status code")) {
      mess = "系统接口" + mess.substr(mess.length - 3) + "异常";
    }
    messageError(error.message);

    return Promise.reject(error);
  }
);

// 处理同一时间只会出现一个错误提示
let flag = false;
const messageError = (RtnMsg) => {
  if (!flag) {
    flag = true;
    message.error(RtnMsg);
    // Vue.$message.error(RtnMsg);
    setTimeout(() => {
      flag = false;
    }, 800);
  }
};

export default service;
